import { render, staticRenderFns } from "./apply_edit.vue?vue&type=template&id=523cff7a&scoped=true"
import script from "./apply_edit.vue?vue&type=script&lang=ts"
export * from "./apply_edit.vue?vue&type=script&lang=ts"
import style0 from "./apply_edit.vue?vue&type=style&index=0&id=523cff7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523cff7a",
  null
  
)

export default component.exports